import React, { useEffect, useState } from "react";
import {
  getAllCategories,
  createCategory,
  updateCategory,
  deleteCategory,
} from "../../../services/adminService";

import {
  Button,
  Table,
  Form,
  Modal,
  Spinner,
  Alert,
} from "react-bootstrap";

const CategoryManagement = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [formData, setFormData] = useState({ name: "", slug: "", description: "" });

  // ✅ Load Categories
  const fetchCategories = async () => {
    try {
      setLoading(true);
      const data = await getAllCategories();
      const sortedCategories = (data.data || []).sort((a, b) =>
      a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
    );
      setCategories(sortedCategories || []);
    } catch (err) {
      setError(err.message || "Failed to load categories");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // ✅ Handle Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ✅ Handle Save (Create/Update)
  const handleSave = async () => {
    try {
      if (editingCategory) {
        await updateCategory(editingCategory._id, formData);
      } else {
        await createCategory(formData);
      }
      setShowModal(false);
      setFormData({ name: "", slug: "", description: "" });
      setEditingCategory(null);
      fetchCategories();
    } catch (err) {
      setError(err.response?.data?.message || "Failed to save category");
    }
  };

  // ✅ Handle Delete
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      try {
        await deleteCategory(id);
        fetchCategories();
      } catch (err) {
        setError(err.response?.data?.message || "Failed to delete category");
      }
    }
  };

  // ✅ Open Modal for Edit
  const handleEdit = (category) => {
    setEditingCategory(category);
    setFormData({
      name: category.name,
      slug: category.slug,
      description: category.description,
    });
    setShowModal(true);
  };

  // ✅ Open Modal for Add
  const handleAdd = () => {
    setEditingCategory(null);
    setFormData({ name: "", slug: "", description: "" });
    setShowModal(true);
  };

  return (
    <div className="container mt-4">
      <h3>📂 Category Management</h3>

      {error && <Alert variant="danger">{error}</Alert>}

      <Button variant="primary" className="mb-3" onClick={handleAdd}>
        ➕ Add Category
      </Button>

      {loading ? (
        <Spinner animation="border" />
      ) : (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Slug</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {categories.length > 0 ? (
              categories.map((cat, idx) => (
                <tr key={cat._id}>
                  <td>{idx + 1}</td>
                  <td>{cat.name}</td>
                  <td>{cat.slug}</td>
                  <td>{cat.description}</td>
                  <td>
                    <Button
                      size="sm"
                      variant="warning"
                      onClick={() => handleEdit(cat)}
                    >
                      ✏️ Edit
                    </Button>{" "}
                    <Button
                      size="sm"
                      variant="danger"
                      onClick={() => handleDelete(cat._id)}
                    >
                      🗑 Delete
                    </Button>
                    
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">
                  No Categories Found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}

      {/* ✅ Modal for Create/Update */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {editingCategory ? "Edit Category" : "Add Category"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-2">
              <Form.Label>Name</Form.Label>
              <Form.Control
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter category name"
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Slug</Form.Label>
              <Form.Control
                name="slug"
                value={formData.slug}
                onChange={handleChange}
                placeholder="Enter slug"
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Description</Form.Label>
              <Form.Control
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Enter description"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CategoryManagement;
// src/components/admin/CategoryCompanyManagement.jsx

// import React, { useEffect, useState } from "react";
// import { Spinner, Alert, Table, Button, Form, FormControl, Badge, Card } from "react-bootstrap";
// import { getCompaniesByCategory, updateCompany } from "../../../services/adminService"; // Adjust path as needed

// const CategoryCompanyManagement = ({ categoryId, categoryName, onBack }) => {
//   const [companies, setCompanies] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [editingRankId, setEditingRankId] = useState(null); // ID of the company being edited
//   const [newRankValue, setNewRankValue] = useState(""); // Value for the input field

//   // Log props to ensure they are received correctly when component mounts or categoryId changes
//   useEffect(() => {
//     console.log("CategoryCompanyManagement mounted/categoryId changed. categoryId:", categoryId, "categoryName:", categoryName);
//     if (!categoryId) {
//       setError("Category ID is missing. Cannot fetch companies for management.");
//     }
//   }, [categoryId, categoryName]);

//   const fetchCompanies = async () => {
//     if (!categoryId) {
//       console.error("fetchCompanies aborted: categoryId is missing.");
//       setError("Cannot fetch companies: Category ID is not available.");
//       setLoading(false); // Ensure loading is stopped
//       return;
//     }

//     try {
//       setLoading(true);
//       setError(""); // Clear previous errors
//       console.log(`Attempting to fetch companies for category ID: ${categoryId}`);

//       const res = await getCompaniesByCategory(categoryId);
//       console.log("Raw response from getCompaniesByCategory:", res);

//       // Validate the response structure
//       if (!res || !res.data || !res.data.data) {
//         throw new Error("Invalid response structure received from the server. Expected { data: { top20: [], alphabetical: [] } }");
//       }

//       const { top20, alphabetical } = res.data.data;
//       const combinedCompanies = [...top20, ...alphabetical];
//       console.log("Fetched top20 companies:", top20);
//       console.log("Fetched alphabetical companies:", alphabetical);
//       console.log("Combined companies before sorting for display:", combinedCompanies);


//       // Sort the combined list for consistent display in the management table
//       combinedCompanies.sort((a, b) => {
//         // Companies with priorityRank come first, sorted by rank
//         // null or undefined priorityRank is treated as no rank for sorting
//         const rankA = a.priorityRank === null || a.priorityRank === undefined ? Infinity : a.priorityRank;
//         const rankB = b.priorityRank === null || b.priorityRank === undefined ? Infinity : b.priorityRank;

//         if (rankA !== Infinity && rankB !== Infinity) return rankA - rankB; // Both have ranks, sort by rank
//         if (rankA !== Infinity) return -1; // Only A has rank, A comes first
//         if (rankB !== Infinity) return 1;  // Only B has rank, B comes first
//         return a.name.localeCompare(b.name); // If neither has rank, sort alphabetically
//       });
//       console.log("Companies after sorting for display:", combinedCompanies);

//       setCompanies(combinedCompanies);
//       setLoading(false);

//       if (combinedCompanies.length === 0) {
//         setError("No approved companies found for this category to manage.");
//       }

//     } catch (err) {
//       console.error("Caught error during fetchCompanies in CategoryCompanyManagement:", err);
//       // Construct a more informative error message
//       const errorMessage = err.response?.data?.message || err.message || "An unknown error occurred.";
//       setError(`Failed to fetch companies for this category: ${errorMessage}`);
//       setLoading(false);
//       setCompanies([]);
//     }
//   };

//   useEffect(() => {
//     fetchCompanies();
//   }, [categoryId]); // Depend on categoryId so it refetches if category changes

//   const handleEditClick = (company) => {
//     console.log("Editing company:", company.name, "Current Rank:", company.priorityRank);
//     setEditingRankId(company._id);
//     setNewRankValue(company.priorityRank === null ? "" : company.priorityRank.toString());
//   };

//   const handleCancelEdit = () => {
//     console.log("Cancelling edit for:", editingRankId);
//     setEditingRankId(null);
//     setNewRankValue("");
//   };

//   const handleSaveRank = async (companyId) => {
//     try {
//       setError("");
//       let rankToSave = null;
//       if (newRankValue !== "") {
//         const parsedRank = parseInt(newRankValue, 10);
//         if (isNaN(parsedRank) || parsedRank < 1 || parsedRank > 20) {
//           setError("Priority Rank must be a number between 1 and 20, or empty to remove.");
//           return;
//         }
//         rankToSave = parsedRank;
//       }
//       console.log(`Attempting to save rank ${rankToSave} for company ID: ${companyId}`);
//       await updateCompany(companyId, { priorityRank: rankToSave }); // Send as JSON payload
//       console.log("Rank updated successfully for company ID:", companyId);
//       setEditingRankId(null);
//       setNewRankValue("");
//       fetchCompanies(); // Re-fetch to see the updated rank and sorting
//     } catch (err) {
//       console.error("Error updating priority rank:", err.response?.data || err.message, err);
//       setError(err.response?.data?.message || `Failed to update priority rank: ${err.message}`);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="text-center mt-5">
//         <Spinner animation="border" />
//         <p>Loading companies for management...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="container mt-4">
//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <h2>Manage Companies in <Badge bg="primary">{categoryName || "Category"}</Badge></h2>
//         <Button variant="secondary" onClick={onBack}>Back to Categories</Button>
//       </div>

//       {error && <Alert variant="danger" className="mt-4">{error}</Alert>}

//       {companies.length === 0 && !loading && !error && ( // Only show if no error and no companies
//         <Alert variant="info" className="text-center">
//           No approved companies found for {categoryName || "this category"} to manage.
//         </Alert>
//       )}

//       {companies.length > 0 && ( // Only show table if there are companies
//         <Table striped bordered hover responsive className="align-middle text-center shadow-sm">
//           <thead className="table-dark">
//             <tr>
//               <th>#</th>
//               <th>Logo</th>
//               <th>Company Name</th>
//               <th>Type</th>
//               <th>Current Rank</th>
//               <th>Set New Rank (1-20 or empty)</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {companies.map((company, index) => (
//               <tr key={company._id}>
//                 <td>{index + 1}</td>
//                 <td>
//                   {company.logo ? (
//                     <img
//                       src={company.logo}
//                       alt={company.name}
//                       style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "4px" }}
//                     />
//                   ) : (
//                     "—"
//                   )}
//                 </td>
//                 <td className="fw-semibold">{company.name}</td>
//                 <td>
//                   <Badge bg={company.companyType === "service" ? "info" : "success"}>{company.companyType}</Badge>
//                 </td>
//                 <td>
//                   {company.priorityRank ? <Badge bg="warning">#{company.priorityRank}</Badge> : "None"}
//                 </td>
//                 <td>
//                   {editingRankId === company._id ? (
//                     <div className="d-flex justify-content-center align-items-center">
//                       <FormControl
//                         type="number"
//                         min="1"
//                         max="20"
//                         placeholder="1-20 or empty"
//                         value={newRankValue}
//                         onChange={(e) => setNewRankValue(e.target.value)}
//                         style={{ width: '120px' }}
//                         className="me-2"
//                       />
//                       <Button variant="success" size="sm" onClick={() => handleSaveRank(company._id)}>
//                         Save
//                       </Button>
//                       <Button variant="secondary" size="sm" className="ms-2" onClick={handleCancelEdit}>
//                         Cancel
//                       </Button>
//                     </div>
//                   ) : (
//                     <Button variant="outline-primary" size="sm" onClick={() => handleEditClick(company)}>
//                       {company.priorityRank ? "Change Rank" : "Set Rank"}
//                     </Button>
//                   )}
//                 </td>
//                 <td>
//                   {/* You can add more actions here like 'Edit Company Details', 'Delete Company' */}
//                   <Button variant="secondary" size="sm" className="me-2">View Details</Button>
//                   {/* Example: <Button variant="danger" size="sm">Delete</Button> */}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </Table>
//       )}
//     </div>
//   );
// };

// export default CategoryCompanyManagement;